<template>
  <div>
    <div v-if="ready">
      <form @submit.prevent="getLink">
        <div class="mdi-card full-width q-pa-md">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <q-field
                orientation="vertical"
                label="Enter Price"
                class="q-pa-md"
                inset="full"
                :icon="errors.has('Price', validatorFormName) ? 'star_border' : 'star'"
                :icon-color="errors.has('Price', validatorFormName) ? 'negative' : 'blue-5'"
                :class="{'is-required': errors.has('Price', validatorFormName)}"
                :error="errors.has('Price', validatorFormName)"
                :error-label="errors.first('Price', validatorFormName)"
                helper="Enter the price you want to charge for a company's registration and receive the link to send them."
              >
                <q-input
                  v-validate="'required|decimal:2'"
                  data-vv-name="Price"
                  v-model="basePrice"
                  type="text"
                  name="price"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="errors.has('Price') ? 'negative' : inputBgColor"
                  :validator-form-name="validatorFormName"
                  :data-vv-scope="validatorFormName"
                />
              </q-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <q-field
                orientation="vertical"
                label="Type"
                class="q-pa-md"
                inset="full"
                :icon="errors.has('Type', validatorFormName) ? 'star_border' : 'star'"
                :icon-color="errors.has('Type', validatorFormName) ? 'negative' : 'blue-5'"
                :class="{'is-required': errors.has('Type', validatorFormName)}"
                :error="errors.has('Type', validatorFormName)"
                :error-label="errors.first('Type', validatorFormName)"
                helper="What type of registration form?"
              >
                <q-select
                  v-validate="'required'"
                  data-vv-name="Type"
                  v-model="type"
                  :options="typeOptions"
                  name="type"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="errors.has('Type') ? 'negative' : inputBgColor"
                  :validator-form-name="validatorFormName"
                  :data-vv-scope="validatorFormName"
                />
                <!-- <q-input
                  v-validate="'required|decimal:2'"
                  data-vv-name="Price"
                  v-model="type"
                  type="text"
                  name="price"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="errors.has('Price') ? 'negative' : inputBgColor"
                  :validator-form-name="validatorFormName"
                  :data-vv-scope="validatorFormName"
                />-->
              </q-field>
            </div>
          </div>
          <div>
            <q-alert
              class="q-ma-lg"
              type="positive"
              icon-right="link"
              :actions="copyClip"
              v-if="link"
            >{{ link }}</q-alert>
          </div>
          <div>
            <div>
              <q-btn
                color="primary"
                @click="getLink"
                class="q-ma-lg"
                push
                size="lg"
              >Get Registration Link</q-btn>
            </div>
            <!-- <div name="goback">
              <q-btn @click="modal = false" color="negative" full class="q-mt-lg">Cancel / Close</q-btn>
            </div>-->
          </div>
        </div>
        <q-inner-loading :visible="loading"></q-inner-loading>
      </form>
    </div>
  </div>
</template>

<script>
import colors from '../../mixins/colors'
// import VeeValidate from 'vee-validate'

// $this.use(VeeValidate)

export default {
  name: 'RegistrationLink',
  inject: ['$validator'],
  mixins: [colors],
  data () {
    return {
      loading: true,
      ready: false,
      basePrice: null,
      type: null,
      validatorFormName: 'registrationLink',
      link: '',
      typeOptions: [
        {
          label: 'Affiliate',
          value: 'affiliate'
        },
        {
          label: 'General/Specialty Contractor',
          value: 'contractor'
        },
         {
           label: 'Project Owner',
          value: 'projectowner'
        }
      ]
    }
  },
  async created () {
    this.ready = true
    this.loading = false
  },
  computed: {
    copyClip () {
      return [
        {
          label: 'Copy to Clipboard',
          icon: 'file_copy',
          handler: () => {
            this.doCopy()
          }
        }
      ]
    }
  },
  filters: {},
  methods: {
    async doCopy () {
      let self = this
      this.$copyText(this.link).then(
        function (e) {
          self.$q.notify({
            type: 'positive',
            message: 'Link has been copied'
          })
          console.log(e)
        },
        function (e) {
          alert('Can not copy')
          console.log(e)
        }
      )
    },
    async getLink () {
      const result = await this.$validator.validate(this.validatorFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      try {
        const { data } = await this.$axios.get('/api/company/createregistrationtoken', {
          params: {
            basePrice: this.basePrice,
            type: this.type
          }
        })
        if (data) {
          this.link = data
        } else {
          this.$q.notify({
            message: 'Error fetching link data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching link data'
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
